import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    id: 'modern',
    name: '现代剧',
    description: '聚焦当代都市生活、职场与情感的写实题材剧集。',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'costume',
    name: '古装剧',
    description: '以古代背景展开的宫廷、江湖与传奇故事。',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'suspense',
    name: '悬疑剧',
    description: '层层反转、抽丝剥茧的高能推理与犯罪题材。',
    icon: 'ri-magic-line',
  },
  {
    id: 'urban',
    name: '都市剧',
    description: '描绘都市青年奋斗、创业与人际关系的现实剧集。',
    icon: 'ri-building-2-line',
  },
  {
    id: 'romance',
    name: '言情剧',
    description: '细腻刻画爱情与成长的甜宠与虐恋故事。',
    icon: 'ri-heart-3-line',
  },
  {
    id: 'scifi',
    name: '科幻剧',
    description: '面向未来的太空、人工智能与末日想象题材。',
    icon: 'ri-rocket-2-line',
  },
  {
    id: 'history',
    name: '历史剧',
    description: '还原时代风云与家国叙事的厚重历史长卷。',
    icon: 'ri-ancient-gate-line',
  },
  {
    id: 'family',
    name: '家庭剧',
    description: '以家庭为纽带，讲述亲情与生活百态的温度故事。',
    icon: 'ri-home-heart-line',
  },
];